// LiveRegion.tsx
const LiveRegion = ({
  message,
  politeness = 'polite',
  atomic = true,
}: { message: string; politeness?: 'polite' | 'assertive'; atomic?: boolean }) => (
  <div
    role={politeness === 'assertive' ? 'alert' : 'status'}
    aria-live={politeness}
    aria-atomic={atomic ? 'true' : 'false'}
    aria-relevant="additions text"
    className="sr-only"
  >
    {message}
  </div>
);

export default LiveRegion;